import { render, staticRenderFns } from "./UserDropTask.vue?vue&type=template&id=995f8580&"
import script from "./UserDropTask.vue?vue&type=script&lang=js&"
export * from "./UserDropTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports